import * as React from "react";
const SvgTick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 12.9375L10.5 18L21 4.5", stroke: "#3FAF2A", strokeWidth: 3 }));
export default SvgTick;
